import { CurrencyPipe } from '@angular/common';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appMoneyMask]',
})
export class MoneyMaskDirective {
  private previousValue = '';
  constructor(private el: ElementRef, private currencyPipe: CurrencyPipe) {}
  ngOnInit(): void {
    this.mask();
  }

  @HostListener('input')
  mask() {
    const masked = this.createMask(this.el.nativeElement.value);
    if (masked !== this.previousValue) {
      this.el.nativeElement.value = masked;
      this.previousValue = masked;
      this.el.nativeElement.dispatchEvent(new Event('input'));
    }
  }

  createMask(value) {
    let maskedValue = value.replace('R$ ', '');
    if (!maskedValue || maskedValue == undefined) {
      return maskedValue;
    }
    maskedValue = this.currencyPipe.transform(maskedValue, 'BRL', 'symbol');

    /*     console.log(maskedValue.length);
      if (maskedValue.length === 0) {
        maskedValue = '000';
      } else if (maskedValue.length <= 3) {
        maskedValue = maskedValue.replace(/^(\d{1})(\d{2})(.*)/, '$1.$2');
      } else if (maskedValue.length <= 5) {
        maskedValue = maskedValue.replace(/^(\d{0,3})(\d{2})(.*)/, '$1,$2');
      } else if (maskedValue.length <= 7) {
        maskedValue = maskedValue.replace(
          /^(\d{0,3})(\d{0,3})(\d{2})(.*)/,
          '$1.$2,$3'
          );
        } else if (maskedValue.length <= 10000) {
          maskedValue = maskedValue.replace(
            /^(\d{0,3})(\d{0,3})(\d{0,2})(.*)/,
            '$1.$2,$3'
            ); */

    return maskedValue;
  }
}
